import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import Node from "./Node";
import { isNode } from "./utils";
var renderBranch = function (branch, path, renderWrapper) {
    if (path === void 0) { path = ''; }
    if (isEmpty(branch))
        return null;
    if (isNode(branch)) { // @ts-ignore
        return _jsx(Node, { component: branch, path: path, renderWrapper: renderWrapper }, path);
    }
    if (Array.isArray(branch))
        return branch.map(function (component, index) { return renderBranch(component, path + '/' + index, renderWrapper); }).filter(Boolean);
    var nodes = {};
    // Objects must be rendered in alphabetical order
    Object.keys(branch).sort().map(function (key) {
        var component = branch[key];
        var rendered = renderBranch(component, path + '/' + key, renderWrapper);
        if (rendered)
            nodes[key] = rendered;
    });
    return isEmpty(nodes) ? null : nodes;
};
export default (function (componentName, data, counterOptions, extraOptions, path) {
    if (extraOptions === void 0) { extraOptions = {}; }
    if (path === void 0) { path = ''; }
    return renderBranch(data, path !== null && path !== void 0 ? path : componentName, extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.callback);
});
